export const MAX_HEIGHT = 'calc(100dvh - 300px)';
// export const MAX_HEIGHT = '80dvh';
